module.exports = __webpack_public_path__ + "static/media/t21.e44aead1.jpg";